export function getResponseErrors(errors, parentKey = "") {
    const messages = [];

    if (Array.isArray(errors)) {
        // It's an array of messages or nested objects
        errors.forEach((item) => {
            if (typeof item === "object" && item !== null) {
                messages.push(...getResponseErrors(item, parentKey));
            } else {
                // Show key only if it's not "non_field_errors" and not empty
                messages.push(
                    parentKey && parentKey !== "non_field_errors"
                        ? `${parentKey}: ${item}`
                        : String(item)
                );
            }
        });
    } else if (typeof errors === "object" && errors !== null) {
        // It's a nested object (field -> errors)
        Object.entries(errors).forEach(([field, value]) => {
            const fullKey =
                field === "non_field_errors"
                    ? parentKey // don't add "non_field_errors" to path
                    : parentKey
                        ? `${parentKey}.${field}`
                        : field;

            messages.push(...getResponseErrors(value, fullKey));
        });
    } else {
        messages.push(
            parentKey && parentKey !== "non_field_errors"
                ? `${parentKey}: ${errors}`
                : String(errors)
        );
    }

    return messages;
}
